import { Button } from '@popsure/dirty-swan';
import classNames from 'classnames';
import { useSafeTranslation } from 'shared/i18n';
import { capitalizeNameSplit } from 'shared/util/capitalizeName';

import styles from './Actions.module.scss';

type ActionsProps = {
  name: {
    firstName: string;
    lastName: string;
  };
  handleContinueWithCurrentAccount: () => void;
  handleCreateNewAccount?: () => void;
};

export const Actions = ({
  name,
  handleContinueWithCurrentAccount,
  handleCreateNewAccount,
}: ActionsProps) => {
  const { t } = useSafeTranslation();

  return (
    <div>
      <Button
        className={`wmn3 mr8 mt16 ${styles.button}`}
        onClick={handleContinueWithCurrentAccount}
        data-cy="button-account-continue"
      >
        {t('components.account.continueas', 'Continue as')}
        {` ${capitalizeNameSplit(name)[0]}`}
      </Button>
      <Button
        className={`wmn3 mt16 ${classNames(styles.button, styles.buttonRight)}`}
        onClick={handleCreateNewAccount}
        variant="filledWhite"
      >
        {t('components.account.chooseAnotherAccount', 'Choose another account')}
      </Button>
    </div>
  );
};
